var _path, _path2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.363 2.19264C12.899 2.43841 11.6154 2.06446 10.5123 1.07078C9.40947 0.077096 8.42723 0.18491 7.56584 1.39395C6.70417 2.60299 5.53238 3.24634 4.04966 3.32347C2.5672 3.40087 1.94858 4.17159 2.19462 5.63563C2.44038 7.09968 2.06644 8.3834 1.0728 9.48652C0.0791522 10.5894 0.186691 11.5717 1.39596 12.4331C2.60495 13.2945 3.24828 14.4666 3.32567 15.9491C3.4028 17.4319 4.17349 18.0503 5.63775 17.8042C7.10174 17.5585 8.38541 17.9324 9.4885 18.9261C10.5913 19.9198 11.5735 19.812 12.4352 18.6029C13.2966 17.3939 14.4687 16.7505 15.9511 16.6731C17.4339 16.596 18.0522 15.8253 17.8062 14.3612C17.5604 12.8969 17.9343 11.6135 18.928 10.5104C19.9216 9.4075 19.8141 8.42522 18.6048 7.56379C17.3958 6.70237 16.7525 5.53026 16.6751 4.04775C16.598 2.56497 15.8273 1.9466 14.363 2.19264Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.363 2.19264C12.899 2.43841 11.6154 2.06446 10.5123 1.07078C9.40947 0.077096 8.42723 0.18491 7.56584 1.39395C6.70417 2.60299 5.53238 3.24634 4.04966 3.32347C2.5672 3.40087 1.94858 4.17159 2.19462 5.63563C2.44038 7.09968 2.06644 8.3834 1.0728 9.48652C0.0791522 10.5894 0.186691 11.5717 1.39596 12.4331C2.60495 13.2945 3.24828 14.4666 3.32567 15.9491C3.4028 17.4319 4.17349 18.0503 5.63775 17.8042C7.10174 17.5585 8.38541 17.9324 9.4885 18.9261C10.5913 19.9198 11.5735 19.812 12.4352 18.6029C13.2966 17.3939 14.4687 16.7505 15.9511 16.6731C17.4339 16.596 18.0522 15.8253 17.8062 14.3612C17.5604 12.8969 17.9343 11.6135 18.928 10.5104C19.9216 9.4075 19.8141 8.42522 18.6048 7.56379C17.3958 6.70237 16.7525 5.53026 16.6751 4.04775C16.598 2.56497 15.8273 1.9466 14.363 2.19264Z",
    fill: "url(#paint0_linear_24689_61348)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_24689_61348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 3.27734C6.28986 3.27734 3.28125 6.23234 3.28125 9.87734C3.28125 13.5223 6.28986 16.4773 10.001 16.4773C13.7121 16.4773 16.7207 13.5223 16.7207 9.87734C16.7207 6.23234 13.7121 3.27734 10.001 3.27734Z",
    fill: "url(#paint1_linear_24689_61348)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24689_61348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15611 12.3967L5.92188 8.65646L8.18465 9.40451L10.036 6.63672L11.8872 9.40451L14.15 8.65646L12.9158 12.3967H7.15611Z",
    fill: "url(#paint2_linear_24689_61348)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_24689_61348)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.0334,
    cy: 6.11343,
    r: 0.33218,
    fill: "url(#paint3_linear_24689_61348)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_24689_61348)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.4845,
    cy: 8.30484,
    r: 0.33218,
    fill: "url(#paint4_linear_24689_61348)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_24689_61348)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.58218,
    cy: 8.30484,
    r: 0.33218,
    fill: "url(#paint5_linear_24689_61348)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26683 5.40625L6.37202 5.72371L6.69186 5.82811L6.37202 5.93252L6.26683 6.24997L6.16164 5.93252L5.8418 5.82811L6.16164 5.72371L6.26683 5.40625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99174 4L5.23718 4.74073L5.98348 4.98434L5.23718 5.22796L4.99174 5.96869L4.7463 5.22796L4 4.98434L4.7463 4.74073L4.99174 4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_24689_61348",
    x: 3.28125,
    y: 3.27734,
    width: 13.6055,
    height: 13.4207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.16609,
    dy: 0.221453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.138408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.291667 0 0 0 0 0.126617 0 0 0 0 0.0157986 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24689_61348"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24689_61348",
    x: 5.53433,
    y: 6.47063,
    width: 9.0036,
    height: 6.53681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.221453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.193772
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24689_61348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24689_61348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_24689_61348",
    x: 9.59045,
    y: 5.78125,
    width: 0.885516,
    height: 0.885516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24689_61348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24689_61348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_24689_61348",
    x: 14.0416,
    y: 7.97266,
    width: 0.885516,
    height: 0.885516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24689_61348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24689_61348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_24689_61348",
    x: 5.13927,
    y: 7.97266,
    width: 0.885516,
    height: 0.885516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.110727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0553633
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.625 0 0 0 0 0.403263 0 0 0 0 0.122396 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24689_61348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24689_61348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24689_61348",
    x1: 10.0004,
    y1: 0.784287,
    x2: 10.0004,
    y2: 19.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490269,
    stopColor: "#F8DB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A409"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24689_61348",
    x1: 10.001,
    y1: 3.27734,
    x2: 10.001,
    y2: 16.4773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9962F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838966,
    stopColor: "#BD722A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24689_61348",
    x1: 10.0359,
    y1: 6.75247,
    x2: 10.0359,
    y2: 12.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377193,
    stopColor: "#F6CB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C30A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24689_61348",
    x1: 10.0334,
    y1: 5.78125,
    x2: 10.0334,
    y2: 6.44561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24689_61348",
    x1: 14.4845,
    y1: 7.97266,
    x2: 14.4845,
    y2: 8.63702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24689_61348",
    x1: 5.58218,
    y1: 7.97266,
    x2: 5.58218,
    y2: 8.63702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldImage);
export default __webpack_public_path__ + "static/media/gold-image.52751a8e2389e301abc47bd1001e74aa.svg";
export { ForwardRef as ReactComponent };